import { render, staticRenderFns } from "./RESINH.vue?vue&type=template&id=65f1796c&"
import script from "./RESINH.vue?vue&type=script&lang=js&"
export * from "./RESINH.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65f1796c')) {
      api.createRecord('65f1796c', component.options)
    } else {
      api.reload('65f1796c', component.options)
    }
    module.hot.accept("./RESINH.vue?vue&type=template&id=65f1796c&", function () {
      api.rerender('65f1796c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/vistas/empresas/61211000-K/RESINH.vue"
export default component.exports